import {useEffect} from 'react';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {InfoSection} from '../../../app/components/InfoSection';
import {useLoginWithTokenMutation} from '../../../app/services/identitiesApi';
import {getInitialRedirectPath} from '../helpers';
export const LoginWithToken = () => {
  const [searchParams] = useSearchParams();
  const params = useParams<{
    token: string;
  }>();
  const navigate = useNavigate();
  const [loginWithToken, {error, isLoading}] = useLoginWithTokenMutation();
  const returnUrl = searchParams.get('returnUrl');
  useEffect(() => {
    if (params.token) {
      loginWithToken({
        token: params.token,
      })
        .unwrap()
        .then((result) => {
          navigate(getInitialRedirectPath(result.token, returnUrl));
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [params.token]);
  if (error) {
    return (
      <InfoSection
        className={'h-full'}
        icon={'exclamation-triangle'}
        message={'The token is invalid or expired. Please try again.'}
        title={'Invalid Token'}
      />
    );
  }
  if (isLoading) {
    return (
      <InfoSection
        className={'h-full'}
        icon={'spinner'}
        iconClassName={'animate-spin'}
        message={'We are verifying authentication token.'}
        title={'Please Wait'}
      />
    );
  }
  return null;
};
